import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';
import { UiFlowNodeFrameComponent } from '../../atoms/flow-node-frame/flow-node-frame.component';

/** Conector en página (círculo). Suele llevar una letra/número corto. */
@Component({
  selector: 'ui-flow-connector-node',
  standalone: true,
  imports: [UiFlowNodeFrameComponent, UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ui-flow-node-frame shape="circle">
      <ui-flow-label [text]="label()" tone="strong" />
    </ui-flow-node-frame>
  `,
  styles: `:host { display: inline-flex; }`,
})
export class UiFlowConnectorNodeComponent {
  readonly label = input.required<string>();
}
